import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { getConnection, QueryRunner, Repository } from "typeorm";
import { WorkOrderInfo } from "./work-order.entity";
import { WorkOrderItems } from "./work-order-items.entity";
import { CommonResponse, WorkOrderLogReq } from "@gtpl/shared-models/production-management";
import { BaleStatusEnum, BaleTypeEnum } from "@gtpl/shared-models/common-models";
import { BaleInfo } from "../bale-generation/bale-info.entity";
import appSettings from "apps/services/config";
import { getManager } from "typeorm";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { WorkOrderDto } from "./dto/work-order.dto";
import { BaleItems } from "../bale-generation/bale-items.entity";
import { ProdlogService, ProductionInventoryService } from "@gtpl/shared-services/production";
import { TabNameReq, WorkOrderInfoReq } from "@gtpl/shared-models/raw-material-procurement";


@Injectable()
export class WorkOrderService {
  constructor(
    @InjectRepository(WorkOrderInfo)
    private workOrderRepo: Repository<WorkOrderInfo>,
    @InjectRepository(WorkOrderItems)
    private workOrderItemsRepo: Repository<WorkOrderItems>,
    @InjectRepository(BaleInfo)
    private baleRepo: Repository<BaleInfo>,
     private prodInvService: ProductionInventoryService,
     private prodLogservice:ProdlogService
  ){}

  async getOpenBaleDetails(req:WorkOrderInfoReq):Promise<CommonResponse>{
    const manager = getManager()
  // let getQry= `SELECT b.id AS baleId,b.bale_no AS baleNo,b.bale_date AS baleDate,b.type AS baleType,b.status,bi.quantity-bi.work_order_qty as remainingQty,
  // bi.id as baleItemId,bi.quality,bi.voucher_no AS voucherNo,bi.quantity AS baleQty,s.name AS agent,p.name AS variant,bi.plant_id as plantId
  // FROM ${appSettings.rm_procure_db}.bale_info b
  // LEFT JOIN ${appSettings.rm_procure_db}.bale_items bi ON bi.bale_id=b.id
  // LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=bi.agent_id
  // LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id = bi.variant_id
  // WHERE b.status!='CLOSED' AND b.type='PRODUCTION' AND bi.quantity-bi.work_order_qty > 0`
  let getQry=`SELECT b.id AS baleId,b.bale_no AS baleNo,b.bale_date AS baleDate,b.type AS baleType,b.status,b.actual_bale_qty AS baleQty,
  b.actual_bale_qty-b.work_order_qty AS remainingQty,p.name AS variant,b.quality 
    FROM demo_erpx_dev_rm_procurement.bale_info b
    LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id = b.variant_id
    WHERE b.status!='CLOSED' AND b.type='PRODUCTION' AND b.actual_bale_qty-b.work_order_qty > 0`
            if(req.baleNumber != undefined){
              getQry += ` AND b.bale_no = '${req.baleNumber}'`
            }
  const result=await this.baleRepo.query(getQry)

if(result.length>0){
    return new CommonResponse(true,1,'Open bale details fetched successfully',result)
  }else{
  return new CommonResponse(false,0,'No open bale details found',null)
  }
}

  async  createWorkOrder(req:WorkOrderDto,queryRunner?: QueryRunner):Promise<CommonResponse>{
    console.log(req,"reqqqqqqqqqq")
    const manager=getManager()
      let isExternalTransaction = true;
  let transactionManager: QueryRunner;

  if (queryRunner) {
    transactionManager = queryRunner;
  } else {
    isExternalTransaction = false;
    const connection = getConnection();
    transactionManager = connection.createQueryRunner();
    await transactionManager.startTransaction();
  }
    //  const transactionManager = new GenericTransactionManager();
       try {
    // await transactionManager.startTransaction();

    const baleItemsRepo = transactionManager.manager.getRepository(BaleItems);
    const baleInfoRepo = transactionManager.manager.getRepository(BaleInfo);

    let newWorkOrderNumber = "";
let savedWorkOrder: any = null;

if (req.baleType == BaleTypeEnum.Export) {
  savedWorkOrder = await transactionManager.manager.getRepository(WorkOrderInfo).findOne({where: {workOrderNo: "W-DUMMY"}});

  if (!savedWorkOrder) {

    const dummyWorkOrder = new WorkOrderInfo();
    dummyWorkOrder.workOrderNo = "W-DUMMY";
    dummyWorkOrder.workOrderDate = req.workOrderDate;
    dummyWorkOrder.remarks = "Dummy WorkOrder For Export Bale";
    dummyWorkOrder.plantId = req.plantId;

    savedWorkOrder = await transactionManager.manager.getRepository(WorkOrderInfo).save(dummyWorkOrder);

    if (!savedWorkOrder) {
      return new CommonResponse(false, 0, 'Failed to create dummy work order', []);
    }
  }

  newWorkOrderNumber = "W-DUMMY";
}

      if (req.baleType != BaleTypeEnum.Export) {

const lastWorkOrder = await transactionManager.manager
  .getRepository(WorkOrderInfo)
  .createQueryBuilder("workOrderInfo")
  .where("workOrderInfo.workOrderNo LIKE :prefix", {
    prefix: "WO-%"
  })
  .orderBy("workOrderInfo.id", "DESC")
  .getOne();

  newWorkOrderNumber = "WO-001";

  if (lastWorkOrder && lastWorkOrder.workOrderNo) {
    const lastNumber = parseInt(lastWorkOrder.workOrderNo.replace("WO-", ""), 10);
    newWorkOrderNumber = `WO-${(lastNumber + 1).toString().padStart(3, '0')}`;
  }

  const workOrderEntity = new WorkOrderInfo();
  workOrderEntity.workOrderNo = newWorkOrderNumber;
  workOrderEntity.workOrderDate = req.workOrderDate;
  workOrderEntity.remarks = req.remarks;
  workOrderEntity.plantId = req.plantId;

  savedWorkOrder = await transactionManager.manager
    .getRepository(WorkOrderInfo)
    .save(workOrderEntity);

  if (!savedWorkOrder) {
    return new CommonResponse(false, 0, 'Failed to create work order', []);
  }
}
 const createdWorkOrderItemIds: number[] = [];
    
    const affectedBaleIds = new Set<number>();
    for (const item of req.workOrderItems) {
      if (!item.baleId || !item.quantity ) {
        // await transactionManager.manager.releaseTransaction();
        return new CommonResponse(false, 0, 'Invalid work order item data', []);
      }

      const workOrderItemEntity = new WorkOrderItems();
      const workOrderEntity=new WorkOrderInfo()
      workOrderEntity.id=savedWorkOrder.id
      workOrderItemEntity.workOrderInfo=workOrderEntity
      workOrderItemEntity.quantity = item.quantity;
      workOrderItemEntity.baleId = item.baleId;

      const savedItem = await transactionManager.manager
        .getRepository(WorkOrderItems)
        .save(workOrderItemEntity);

        createdWorkOrderItemIds.push(savedItem.id);

      if (!savedItem) {
        // await transactionManager.releaseTransaction();
        return new CommonResponse(false, 0, 'Failed to save work order items', []);
      }
       const baleItem = await baleInfoRepo.findOne({
        where: { id: item.baleId }
      });
      if (!baleItem) {
        // await transactionManager.releaseTransaction();
        return new CommonResponse(false, 0, `Bale item not found`, []);
      }
      baleItem.workOrderQty = Number(baleItem.workOrderQty || 0) + Number(item.quantity);

      const updatedBaleItem = await baleInfoRepo.save(baleItem);

      if (!updatedBaleItem) {
        // await transactionManager.releaseTransaction();
        return new CommonResponse(false, 0, 'Failed to update bale item qty', []);
      }

      affectedBaleIds.add(item.baleId);
    }
    for (const baleId of affectedBaleIds) {
      const result = await baleInfoRepo
        .createQueryBuilder("bi")
        .select("SUM(bi.workOrderQty)", "total")
        .where("bi.id = :baleId", { baleId })
        .getRawOne();

      const totalWOQty = Number(result?.total || 0);

      const baleInfo = await baleInfoRepo.findOne({where: { id: baleId }});

      if (!baleInfo) {
        throw new Error(`Bale info not found: ${baleId}`);
      }

      const baleQty = Number(baleInfo.quantity);

      if (totalWOQty === baleQty) {
        baleInfo.status = BaleStatusEnum.CLOSED;
      } else if (totalWOQty > 0 && totalWOQty < baleQty) {
        baleInfo.status = BaleStatusEnum.INPROGRESS;
      }
      const updatedBaleInfo = await baleInfoRepo.save(baleInfo);

      if (!updatedBaleInfo) {
        throw new Error("Failed to update bale status");
      }
    }
    const getQualityVariantQry=`SELECT b.id as baleId,b.quality,b.variant_id AS variantId,p.name as variantName from ${appSettings.rm_procure_db}.bale_info b 
    left join ${appSettings.masters_db}.products p on p.product_id=b.variant_id
    WHERE b.id in (${[...affectedBaleIds].join(',')})`
    const qualityVariantRes=await baleInfoRepo.query(getQualityVariantQry)
    const baleMetaMap: Record<number, any> = {};
    qualityVariantRes.forEach((item: any) => {
  if (!baleMetaMap[item.baleId]) {
    baleMetaMap[item.baleId] = {
      quality: item.quality || null,
      variantId: item.variantId,
      variantName: item.variantName
    };
  }
});
const groupMap: Record<string, any> = {};
req.workOrderItems.forEach((item: any) => {
  const meta = baleMetaMap[item.baleId];
  if (!meta) return;

  const qualityKey = meta.quality ?? "NULL";

  const key = `${qualityKey}_${meta.variantId}`;

  if (!groupMap[key]) {
    groupMap[key] = {
      quality: meta.quality,
      variantId: meta.variantId,
      variantName: meta.variantName,
      totalQty: 0
    };
  }

  groupMap[key].totalQty += Number(item.quantity || 0);
});

const groupedData = Object.values(groupMap);


 for (const group of groupedData as any[]) {
  console.log(group,"grouppppppppppppppppppppppppppppppppp")

   const getSkuCodeQuery=`SELECT sku_code_id as skuCodeId FROM ${appSettings.masters_db}.sku_codes WHERE short_code='${group.variantName}'`
  const getSkuCodeId=await manager.query(getSkuCodeQuery)
  console.log(getSkuCodeId,"getSkuCodeId")
 const skuCodeId =
  req?.baleType == BaleTypeEnum.Export
    ? getSkuCodeId?.[0]?.skuCodeId || group.variantId
    : group.variantId;
console.log(skuCodeId,"skuCodeIddddddd" )
  const prodInvReq = new WorkOrderLogReq(newWorkOrderNumber,req.workOrderDate,req.plantId,group.totalQty,undefined,undefined,group.quality,skuCodeId,group.variantName);
console.log(prodInvReq,"!!!!!!!!!!!!!!!!!!!!!!!11")
  const prodInvRes = await this.prodInvService.createInvForWorkOrder([prodInvReq]);
console.log(prodInvRes,"@@@@@@@@@@@@@@@@@@@@")
  if (!prodInvRes.status) {
    throw new Error('Failed to create inventory for work order');
  }

const inInvId = prodInvRes.data?.inId;
const outInvId = prodInvRes.data?.outId;

if (!inInvId || !outInvId) {
  throw new Error('Invalid inventory ids returned');
}

  const prodLogReq = new WorkOrderLogReq(newWorkOrderNumber,req.workOrderDate,req.plantId,group.totalQty,null,req.remarks,group.quality,skuCodeId,group.variantName,inInvId,outInvId);
console.log(prodLogReq,"prodLogReq")
  const prodLogRes = await this.prodLogservice.createLogForWorkOrder(prodLogReq);
console.log(prodLogRes,"prodLogRes")
  if (!prodLogRes.status) {
    throw new Error('Failed to create production log');
  }

  if (req.baleType == BaleTypeEnum.Export) {
    const lotCodeRes = await this.prodLogservice.createLotCodeForExportBales(
      prodLogReq,
      transactionManager
    );
console.log(lotCodeRes,"lotCodeRes")
    const generatedLotNumber = lotCodeRes.data?.lotNumber;
console.log(generatedLotNumber,"generatedLotNumber")
    if (!generatedLotNumber) {
  throw new Error("Lot number not generated");
}
console.log(generatedLotNumber,"generatedLotNumber")
console.log(createdWorkOrderItemIds,"createdWorkOrderItemIds")
await transactionManager.manager.createQueryBuilder().update(WorkOrderItems).set({lotNumber: generatedLotNumber})
   .where("id IN (:...ids)", { ids: createdWorkOrderItemIds})
  .execute();

    if (!lotCodeRes.status) {
      throw new Error('Failed to create lot code');
    }
  }
}
    if (!isExternalTransaction) {
      await transactionManager.commitTransaction();
      await transactionManager.release();
    }
    // await transactionManager.completeTransaction();
    return new CommonResponse(true, 1, "Work Order Created Successfully",[]);
  } catch (err) {
    // await transactionManager.releaseTransaction();
     if (!isExternalTransaction) {
      await transactionManager.rollbackTransaction();
      await transactionManager.release();
    }
    return new CommonResponse(false, 0, 'Internal server error', []);
  }
}

  async getVoucherNumberDropDownInfo(req:TabNameReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQry
      if(req.tabName == 'Open'){
        getQry = `SELECT bi.voucher_no as voucherNumber FROM ${appSettings.rm_procure_db}.bale_info b 
                  LEFT JOIN ${appSettings.rm_procure_db}.bale_items bi ON bi.bale_id=b.id
                  WHERE b.status!='CLOSED' AND b.type='PRODUCTION'
                  GROUP BY bi.voucher_no`
      }else{
        getQry = `SELECT bi.voucher_no as voucherNumber FROM ${appSettings.rm_procure_db}.work_order_items woi
                  LEFT JOIN ${appSettings.rm_procure_db}.bale_items bi ON bi.id=woi.bale_item_id
                  GROUP BY bi.voucher_no`
      }
      const voucherNumberInfo = await manager.query(getQry)
      if(voucherNumberInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',voucherNumberInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

    async getAgentDropDownInfo(req:TabNameReq):Promise<CommonResponse>{
      const manager = getManager()
      try{
        let getQry
        if(req.tabName == 'Open'){
          getQry = `SELECT su.name AS agent FROM ${appSettings.rm_procure_db}.bale_info b 
                  LEFT JOIN ${appSettings.rm_procure_db}.bale_items bi ON bi.bale_id=b.id
                  LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id=bi.agent_id
                  WHERE b.status!='CLOSED' AND b.type='PRODUCTION'
                  GROUP BY bi.agent_id`
        }else{
          getQry = `SELECT su.name AS agent FROM ${appSettings.rm_procure_db}.work_order_items woi
                  LEFT JOIN ${appSettings.rm_procure_db}.bale_items bi ON bi.id=woi.bale_item_id
                  LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id=bi.agent_id
                  GROUP BY bi.agent_id`
        }
        const agentInfo = await manager.query(getQry)
        if(agentInfo.length > 0){
          return new CommonResponse(true,1,'Data retrieved',agentInfo)
        }else{
          return new CommonResponse(false,0,'No data found')
        }
      }catch(err){
        throw err
      }
    }

        async getBaleNumberDropDownInfo(req:TabNameReq):Promise<CommonResponse>{
      const manager = getManager()
      try{
        let getQry
        if(req.tabName == 'Open'){
          getQry = `SELECT bale_no as baleNumber FROM ${appSettings.rm_procure_db} .bale_info
                  WHERE status!='CLOSED' AND type='PRODUCTION'
                  GROUP BY bale_no`
        }else{
          getQry = `SELECT bale_no as baleNumber FROM ${appSettings.rm_procure_db} .bale_info
                  WHERE status!='OPEN' AND type='PRODUCTION'
                  GROUP BY bale_no`
        }
        const baleNumberInfo = await manager.query(getQry)
        if(baleNumberInfo.length > 0){
          return new CommonResponse(true,1,'Data retrieved',baleNumberInfo)
        }else{
          return new CommonResponse(false,0,'No data found')
        }
      }catch(err){
        throw err
      }
    }

      async getWONumberDropDownInfo():Promise<CommonResponse>{
        const manager = getManager()
        try{
          const getQry = `SELECT work_order_no as workOrderNo FROM ${appSettings.rm_procure_db}.work_order_info`
          const workOrderInfo = await manager.query(getQry)
    
          if(workOrderInfo.length > 0){
            return new CommonResponse(true,1,'Data retrieved',workOrderInfo)
          }else{
            return new CommonResponse(false,0,'No data found')
          }
        }catch(err){
          throw err
        }
      }

        async getWorkOrderInfo(req:WorkOrderInfoReq):Promise<CommonResponse>{
          const manager = getManager()
          try{
            let getQry = `SELECT wo.id AS workOrderId,wo.work_order_no AS workOrderNo,wo.work_order_date AS workOrderDate,wo.remarks,woi.quantity AS workOrderQty,b.bale_no AS baleNo,
            b.quality,b.actual_bale_qty AS baleQty,b.plant_id,p.name AS variant,b.bale_date AS baleDate
            FROM ${appSettings.rm_procure_db}.work_order_info wo
            LEFT JOIN ${appSettings.rm_procure_db}.work_order_items woi ON woi.work_order_id=wo.id
            LEFT JOIN ${appSettings.rm_procure_db}.bale_info b ON b.id=woi.bale_id
            LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id = b.variant_id
            WHERE wo.id > 0
            `
            if(req.workOrderNo != undefined){
              getQry += ` AND wo.work_order_no = '${req.workOrderNo}'`
            }
            if(req.baleNumber != undefined){
              getQry += ` AND b.bale_no = '${req.baleNumber}'`
            }
      
            const baleInfo = await manager.query(getQry)
            if(baleInfo.length > 0){
              return new CommonResponse(true,1,'Data retrieved',baleInfo)
            }else{
              return new CommonResponse(false,0,'No data found')
            }
          }catch(err){
            throw err
          }
        }
}